import { useQuery } from '@tanstack/react-query';
import getReferrersGroups from '../api/getReferrersGroups';

export const GET_REFERRERS_GROUPS_QUERY_KEY = 'GET_REFERRERS_GROUPS';

const useGetReferrersGroup = (searchTerm: string) => {
  const { data: referrersGroup, ...rest } = useQuery({
    queryFn: () => getReferrersGroups(searchTerm),
    onSuccess: () => {},
    queryKey: [GET_REFERRERS_GROUPS_QUERY_KEY, searchTerm],
  });

  return { ...rest, referrersGroup };
};

export default useGetReferrersGroup;
